import React, { ReactNode, useMemo, useState } from "react";
import "./SceneCanvas.scss";
import { Canvas } from "@react-three/fiber";
import { gui } from "../../../App";
import { Controller } from "lil-gui";

interface IProps {
    children: ReactNode;
}

interface FilterState {
    contrast: number
    saturate: number
}

export function SceneCanvas(props: IProps) {
    const [style, setStyle] = useState<React.CSSProperties>();

    useMemo(() => {
        const state: FilterState = {
            contrast: 1.009,
            saturate: 1.765,
        };
        const updateFilter = (currentFilter: string, key: keyof FilterState, value: number) => {
            const remainingFilters = currentFilter.split(' ').filter((filterSetting) => {
                return filterSetting.split(key).length === 1;
            });
            const newFilters = [
                ...remainingFilters,
            ]
            newFilters.push(`${key}(${value})`);
            return newFilters.join(' ');
        }

        gui.children.forEach((child) => {
            if ((child as Controller).property === 'saturate') {
                child.destroy();
            }
        })
        gui.children.forEach((child) => {
            if ((child as Controller).property === 'contrast') {
                child.destroy();
            }
        })
        gui.add(state, 'contrast', 0, 3, 0.001)
            .name('Scene contrast')
            .onChange((value: number) => {
                setStyle((prevState) => {
                    // console.log({filter: prevState?.filter ?? ''});
                    const filter = updateFilter((prevState?.filter ?? ''), 'contrast', value);

                    return {
                        ...prevState,
                        filter,
                    }
                })
            });
        gui.add(state, 'saturate', 0, 10, 0.001)
            .name('Scene saturation')
            .onChange((value: number) => {
                setStyle((prevState) => {
                    const filter = updateFilter((prevState?.filter ?? ''), 'saturate', value);
                    // console.log({filter});

                    return {
                        ...prevState,
                        filter,
                    }
                })
            });
    }, []);

    return (
        <div className="scene-canvas-wrapper">
            <Canvas camera={{ position: [16, 8, -10] }} shadows={"soft"} style={style ?? {
                filter: 'contrast(1.009) saturate(1.765)'
            }}>
                {props.children}
            </Canvas>
        </div>
    )
}
